module.exports = __webpack_public_path__ + "img/11.f910e95a.jpg";